export default function(state = {}, action) {

	switch (action.type)
	{
		//default just return state
		default:
			return state;
	}
}
